import React from 'react';

const TrustBlocks = () => {
  return (
    <section className="trust-section">
      <p className="eyebrow-tag">Trust built in</p>
      <h2>Compliance and security you can trust.</h2>
      <div className="trust-grid">
        <article className="trust-card">
          <h3>Ontario Compliance</h3>
          <p>RTA-aligned workflows keep you LTB-ready.</p>
        </article>
        <article className="trust-card">
          <h3>Landlord Verified</h3>
          <p>Verified landlords create a trusted marketplace.</p>
        </article>
        <article className="trust-card">
          <h3>Secure by Design</h3>
          <p>Encrypted files and role-based access protect data.</p>
        </article>
      </div>
    </section>
  );
};

export default TrustBlocks;
